import { render, staticRenderFns } from "./Transliterate.vue?vue&type=template&id=63b9a01d&scoped=true"
import script from "./Transliterate.vue?vue&type=script&lang=js"
export * from "./Transliterate.vue?vue&type=script&lang=js"
import style0 from "./Transliterate.vue?vue&type=style&index=0&id=63b9a01d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9a01d",
  null
  
)

export default component.exports